import axios from "axios";

import {
  flattenObject,
  getFinalKeySegment,
  castToFloatAndReducePrecision,
} from "./utils";

//const API_URL_PREFIX = "https://uadpap241l.execute-api.us-west-2.amazonaws.com/stage/api"
//const API_URL_PREFIX = "https://83tlx6qqwa.execute-api.us-west-2.amazonaws.com/production/api"

// initialize URL for docker/local development
let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000/api";
// override API_URL_PREFIX based on REACT_APP_ENV for AWS deployment
const REACT_APP_ENV = process.env.REACT_APP_ENV || "local";
if (REACT_APP_ENV === "production") {
  apiUrl =
    "https://1dce7cw76c.execute-api.us-west-2.amazonaws.com/production/api";
} else if (REACT_APP_ENV === "stage") {
  apiUrl = "https://b9ndh4g9p8.execute-api.us-west-2.amazonaws.com/stage/api";
} else if (REACT_APP_ENV === "dev") {
  apiUrl = "https://wqgoohjeub.execute-api.us-west-2.amazonaws.com/dev/api";
}
// set API_URL_PREFIX
const API_URL_PREFIX = apiUrl;

const defaultQueryParameters = {
  limit: "20000",
};

const buildQueryString = (params) => {
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  return queryString ? `${queryString}` : "";
};

/**
 * A class containing methods for making API calls to the backend.
 * @class
 */
class ServiceClass {
  /**
   * @constructor
   */
  constructor() {
    this.api = axios.create({
      baseURL: API_URL_PREFIX,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  }

  /**
   * Get Queries.
   * @returns {}
   */
  async queries() {
    let requestConfig = {
      headers: {},
    };
    let url = "/data/queries";

    // if (user.token) {
    //     requestConfig.headers['Authorization'] = `Bearer ${user.token}`;
    // }

    const response = await this.api.get(url, requestConfig);
    return response.data;
  }

  /**
   * Execute query.
   * @returns {}
   */
  async query(filteredColumns, queryParameters) {
    let requestConfig = {
      headers: {},
    };
    let url = `/data/query?mode=find&filter=${filteredColumns}&${buildQueryString(defaultQueryParameters)}&${buildQueryString(queryParameters)}`;

    // if (user.token) {
    //     requestConfig.headers['Authorization'] = `Bearer ${user.token}`;
    // }

    const response = await this.api.get(url, requestConfig);

    return response.data;
  }

  /**
   * Execute unfiltered query.
   * @returns {}
   */
  async unfilteredQuery(queryParameters) {
    let requestConfig = {
      headers: {},
    };
    let url = `/data/query?mode=find&${buildQueryString(defaultQueryParameters)}&${buildQueryString(queryParameters)}`;

    // if (user.token) {
    //     requestConfig.headers['Authorization'] = `Bearer ${user.token}`;
    // }

    const response = await this.api.get(url, requestConfig);

    return response.data;
  }

  /**
   * Execute query.
   * @returns {}
   */
  async queryAndFlatten(filteredColumns, queryParameters, sortColumn) {
    let requestConfig = {
      headers: {},
    };
    let url = `/data/query?mode=find&filter=${filteredColumns}&${buildQueryString(defaultQueryParameters)}&${buildQueryString(queryParameters)}`;

    // if (user.token) {
    //     requestConfig.headers['Authorization'] = `Bearer ${user.token}`;
    // }

    const response = await this.api.get(url, requestConfig);

    const flattenedData = response.data.result?.map((item) =>
      flattenObject(item),
    );
    // Filter out keys that contain extra values
    const tableData = {};
    tableData.result = flattenedData.map((item) => {
      let filteredItem = {};
      for (const key in item) {
        if (key.includes("catalyst_elements")) {
          const newKey = "catalyst_elements";
          if (!filteredItem[newKey]) {
            filteredItem[newKey] = item[key];
          } else {
            filteredItem[newKey] = filteredItem[newKey] + " " + item[key];
          }
        } else if (
          !key.includes(".dft_electronic_structure.") &&
          !key.includes(".dft_physical_structure.")
        ) {
          const newKey = getFinalKeySegment(key);
          //if (!filteredItem[newKey]) {
          if (
            key === "_id" ||
            key === "unique_id" ||
            key === "adsorbed_state.catalyst_facet" ||
            key === "reaction.catalyst_facet"
          ) {
            filteredItem[newKey] = item[key];
          } else if (
            key === "adsorbed_state.dft_solvation_expparams.applied_potential"
          ) {
            if (item[key] !== null) {
              filteredItem[newKey] = castToFloatAndReducePrecision(item[key]);
            } else {
              filteredItem[newKey] = "No Bias";
            }
          } else {
            filteredItem[newKey] = castToFloatAndReducePrecision(item[key]);
          }
          //}
        }
      }
      return filteredItem;
    });

    return tableData;

    // const sortedTableData = {};
    // sortedTableData.result = tableData.result.sort((a, b) =>
    //     (a[sortColumn] || 0) - (b[sortColumn] || 0));

    // return sortedTableData;
  }

  async columns() {
    let requestConfig = {
      headers: {},
    };
    let url = "/metadata/columns";

    // if (user.token) {
    //     requestConfig.headers['Authorization'] = `Bearer ${user.token}`;
    // }

    const response = await this.api.get(url, requestConfig);
    return response.data;
  }

  async reactionColumns() {
    let requestConfig = {
      headers: {},
    };
    let url = "/metadata/reaction_columns";

    // if (user.token) {
    //     requestConfig.headers['Authorization'] = `Bearer ${user.token}`;
    // }

    const response = await this.api.get(url, requestConfig);
    return response.data;
  }
}

export const serviceApi = new ServiceClass();
